const AI = 'AI'
const AUTO = 'Auto'
const CONTENT = 'Content'
const DESIGN = 'Design'
const AUDIO = 'Audio'
const SETTINGS = 'Settings'
const TAB_NAMES = {
  AI, AUTO, CONTENT, DESIGN, AUDIO, SETTINGS,
}
const AI_HEADER = 'Edit with AI'
const AUTO_HEADER = ['Improve Writing', 'Create']
const CONTENT_HEADER = ['Type', 'Content', 'Templates']
const DESIGN_HEADER = 'Design'
const AUDIO_HEADER = ['Slide', 'Presentation']
const SETTINGS_HEADER = 'Settings'

const ALL_TABS = {
  AI: {
    name: AI,
    icon: 'sparkles',
    iconWidth: 24,
    iconHeight: 24,
    iconViewBox: '0 0 20 20',
    header: AI_HEADER,
  },
  AUTO: {
    name: AUTO,
    icon: 'sparkles',
    iconWidth: 24,
    iconHeight: 24,
    iconViewBox: '0 0 20 20',
    header: AUTO_HEADER,
  },
  CONTENT: {
    name: CONTENT,
    icon: 'edit-2',
    iconWidth: 24,
    iconHeight: 24,
    iconViewBox: '0 0 20 20',
    header: CONTENT_HEADER,
  },
  DESIGN: {
    name: DESIGN,
    icon: 'palette-2',
    iconWidth: 24,
    iconHeight: 24,
    iconViewBox: '0 0 20 20',
    header: DESIGN_HEADER,
  },
  AUDIO: {
    name: AUDIO,
    icon: 'music-note',
    iconWidth: 24,
    iconHeight: 24,
    iconViewBox: '0 0 24 24',
    header: AUDIO_HEADER,
  },
  SETTINGS: {
    name: SETTINGS,
    icon: 'setting',
    iconWidth: 24,
    iconHeight: 24,
    iconViewBox: '0 0 24 24',
    header: SETTINGS_HEADER,
  },
}

export default {
  TAB_NAMES,
  ALL_TABS,
  AUTO_HEADER,
}
